export default __webpack_public_path__ + "static/media/eva.86ee528b.jpeg";